import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  url: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

const defaultProps = {
  url: null,
  height: '500px',
  width: '100%',
};

const IFrame = ({ url, height, width }) => {
  if (!url) { return null; }

  return <iframe src={url} width={width} height={height} />;
};

IFrame.propTypes = propTypes;
IFrame.defaultProps = defaultProps;
export default IFrame;
